;(function () {
  'use strict'
  angular
    .module('contrast.application.coverage')
    .controller(
      'AppCoverageCtrl',
      function (
        $scope,
        $filter,
        $routeParams,
        ApplicationFactory,
        ErrorService,
        RULE_SEVERITY_ORDER
      ) {
        var _searchKeywords = '',
          _appId = $routeParams.appId,
          pageSize = 50

        angular.extend($scope, {
          model: {
            urls: [],
            loading: false,
            firstLoad: true,
            total: 0
          },
          row: '-last_time_seen'
        })

        angular.extend($scope, {
          onFilterChange: onFilterChange,
          reload: reload,
          searchKeywords: searchKeywords,
          order: order
        })

        function init() {
          _startLoadingUrls()
        }

        function searchKeywords(newSearchKeywords) {
          if (!arguments.length) {
            return _searchKeywords
          }

          if (newSearchKeywords !== _searchKeywords) {
            _searchKeywords = newSearchKeywords
          }

          _startLoadingUrls()

          return _searchKeywords
        }

        function _startLoadingUrls() {
          _loadUrls().then(function () {
            $scope.model.firstLoad = false
          })
        }

        function _loadUrls() {
          $scope.model.loading = true
          return ApplicationFactory.getCoverage(
            _appId,
            _searchKeywords,
            pageSize
          )
            .then(function (response) {
              $scope.model.urls = response.data.urls
              $scope.model.total = response.data.count
            })
            .then(onFilterChange)
            .catch(ErrorService.processError)
            .finally(function () {
              $scope.model.loading = false
            })
        }

        function reload() {
          _startLoadingUrls()
        }

        function onFilterChange() {
          $scope.order($scope.row)
        }

        function order(rowName) {
          $scope.row = rowName
          if (rowName.indexOf('vulnerable') > -1) {
            return ($scope.model.urls = $scope.model.urls.sort(function (a, b) {
              var valueA = -1,
                valueB = -1
              if (a.severity != null) {
                valueA = RULE_SEVERITY_ORDER.indexOf(a.severity.toUpperCase())
              }
              if (b.severity != null) {
                valueB = RULE_SEVERITY_ORDER.indexOf(b.severity.toUpperCase())
              }

              return rowName.indexOf('-') > -1
                ? valueB - valueA
                : valueA - valueB
            }))
          } else {
            return ($scope.model.urls = $filter('orderBy')(
              $scope.model.urls,
              rowName
            ))
          }
        }

        init()
      }
    )
})()
